import i18next from 'i18next';

i18next.addResources('es', 'common', {
  unpublished: 'No Publicado'
});

i18next.addResources('en', 'common', {
  unpublished: 'Unpublished'
});

i18next.addResources('pt', 'common', {
  unpublished: 'Não Publicado'
});
